<template>
  <div v-if="home" class="home">
    <span>약관 및 정책</span>
    <span class="title">바로돌봄 서비스 이용에 대한<br/> 약관 및 정책 확인이 가능해요</span>
    <div class="box" @click="change(1)">
        <span>서비스 이용약관</span>
        <img class="arrow" src="../../assets/icn.png" />
    </div>
    <div class="box" @click="change(2)">
        <span>개인정보 처리방침</span>
        <img class="arrow" src="../../assets/icn.png" />
    </div>
    <div class="box" @click="change(3)">
        <span>개인정보 수집 이용 제공 동의 항목</span>
        <img class="arrow" src="../../assets/icn.png" />
    </div>
  </div>
  <router-view v-else />
</template>

<script>


export default {
    name: 'policy',
    data: function()
    {
        return {
            home: true,
            contents: null
        }
    },
    mounted: function()
    {
        if(this.$route.fullPath !== '/barocare')
        {
            this.home = false;
        }      
    },  
    methods: {
        change: function(view)
        {
            this.home = false;

            if(view === 1)
            {
                this.$router.push({path: '/barocare/terms'})
            }
            else if(view === 2)
            {
                this.$router.push({path: '/barocare/privacy'})
            }
            else if(view === 3)
            {
                this.$router.push({path: '/barocare/use'})
            }
        }
    },
    watch: {
        $route(to, from) {

            if(from.fullPath !== '/barocare')
            {
              
                this.home = true;
                
            }
            else
            {
                this.home = false;
            }
        }
    }
}
</script>

<style scoped>
.home {
        display: flex;
        flex-direction: column;
    }
    .title {
        font-size: 20px;
        font-weight: bold;
        margin-top: 30px;
        margin-bottom: 30px;
    }
    .box {
        height: 65px;
        border-bottom: 1px solid #E8EAEE;
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
    }
    .arrow {
        width: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/barocare/Policy.vue